import { Component, OnInit, Renderer2 } from '@angular/core';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  styles: [
    `
      :host {
        min-height: 100vh;
      }
    `,
  ],
})
export class MainComponent implements OnInit {
  public sidebarMenuOpened = true;
  public sidebarOpenAfterBreakpoint: boolean = false;
  public currentWidth: number = null;

  constructor(private renderer: Renderer2) {
    window.onload = (ev: Event) => {
      this.sidebarManager(ev);
      this.currentWidth = window.outerWidth;
    };
  }

  ngOnInit() {
    this.checkViewportWidthAndManageSidebar('resize', window);
  }

  toggleMenuSidebar() {
    const body: HTMLBodyElement = document.querySelector('body');

    if (body.classList.contains('sidebar-closed'))
      this.renderer.removeClass(body, 'sidebar-closed'); // To atleast show the collapsed state

    if (this.sidebarMenuOpened) {
      this.renderer.addClass(body, 'sidebar-collapse');
      this.renderer.removeClass(body, 'sidebar-open');
      this.sidebarMenuOpened = false;
    } else {
      this.renderer.removeClass(body, 'sidebar-collapse');
      this.renderer.addClass(body, 'sidebar-open');
      this.sidebarMenuOpened = true;
    }

    if (window.outerWidth < ScreenSizes.SCREEN_LG) {
      this.sidebarOpenAfterBreakpoint = true;
    }
  }

  checkViewportWidthAndManageSidebar(ev: string, el: HTMLElement | Window) {
    fromEvent(el, ev).subscribe((event) => {
      this.sidebarManager(event);
    });
  }

  sidebarManager(ev: Event) {
    const body: HTMLBodyElement = document.querySelector('body');
    const winWidth: number = window.outerWidth;

    if (winWidth > ScreenSizes.SCREEN_LG && this.sidebarOpenAfterBreakpoint) {
      this.sidebarOpenAfterBreakpoint = false;
    }

    if (!this.sidebarOpenAfterBreakpoint) {
      if (winWidth <= ScreenSizes.SCREEN_LG) {
        this.renderer.addClass(body, 'sidebar-closed');
        this.renderer.addClass(body, 'sidebar-collapse');
        this.renderer.removeClass(body, 'sidebar-open');
        this.sidebarMenuOpened = false;
      } else {
        this.renderer.removeClass(body, 'sidebar-closed');
        this.renderer.removeClass(body, 'sidebar-collapse');
        if (!body.classList.contains('sidebar-open'))
          this.renderer.addClass(body, 'sidebar-open');
        this.sidebarMenuOpened = true;
      }
    }
  }
}

enum ScreenSizes {
  SCREEN_LG = 991.98,
  SCREEN_MD = 767.98,
}
